import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, CORE, CORE_JOB_COMPANY } from "../../common/URLs";

export const fetchJobCompanyList = async () => {
    const url = `${BASE_URL}/${CORE}/${CORE_JOB_COMPANY}`; // Proxy path
    try {
      const token = await fetchToken()
      
      const response = await fetch(url, {
        method: "GET",
        headers: { 
          'Accept': "application/json",
          'Authorization':
            `Bearer ${token}`,
        },
      });
    //   console.log("response", response)
      const data = await response.json();
      return data;
    }catch(error){
        // console.log("error", error)
        return error  
    }
  };


  
export const addJobCompany = async (newJobCompany) => {
  const url = `${BASE_URL}/${CORE}/${CORE_JOB_COMPANY}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newJobCompany),
    });
    const data = await response.json();
    // console.log("API Data", data);
    return data;
  } catch (error) {
    // console.log("error", error);
    throw error;
  }
};

export const deleteJobCompany = async (uuid) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${BASE_URL}/${CORE}/${CORE_JOB_COMPANY}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error deleting job company: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting job company: " + error.message);
  }
};

export const updateJobCompany = async (uuid, jobCompanyData) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${BASE_URL}/${CORE}/${CORE_JOB_COMPANY}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(jobCompanyData),
    });

    if (!response.ok) {
      throw new Error("Error updating job company: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating job company: " + error.message);
  }
};
